import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Constants from "../../services/constant";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { useHistory } from "react-router-dom";
import { getData, postData, postData1, putData, putData1 } from "../../services/http.service";
import { InputTextarea } from "primereact/inputtextarea";
import Cross from "../../assets/demo/flags/cross.png";
import moment from "moment/moment";
import { Image } from "primereact/image";
import profile from "../../assets/demo/flags/profile.png";
import { Chips } from "primereact/chips";

const StateLawsEdit = () => {
    const { id } = useParams();
    const toast = useRef(null);
    const history = useHistory();



    const [loading, setLoading] = useState(true);
    const [stateLawInfo, setStateLawInfo] = useState({
        state:null,
        url:null
    });

    const [err, setErr] = useState({});



 const handleChange = ({name,value}) => {
    setStateLawInfo((prev)=>{
        return {
            ...prev,
            [name]:value
        }
    })

    setErr({ ...err, [name]: "" })
 }

    const validateForm = () => {
        let errors = {};
        if (!stateLawInfo.state) {
            errors.state = "State is required";
        }
        if (!stateLawInfo.url) {
            errors.url = "URL is required";
        }


        setErr(errors);
        if (Object.keys(errors).length === 0) {
            return true;
        } else {
            return false;
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = validateForm();
        if (form) {
            putData(Constants.END_POINT.UPDATE_STATE_LAWS+id, stateLawInfo)
                .then((res) => {
                    if (res.success) {
                        toast.current.show({ severity: "info", summary: "", detail: "State Law has been Updated Succesfully", life: 3000 });
                                    setTimeout(()=>history.push("/state-laws"), 1000)
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            window.scrollTo({
                top: 250,
                left: 0,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        getSingleStateLaw();
    }, []);

    const getSingleStateLaw = () => {
        getData(Constants.END_POINT.SINGLE_STATE_LAWS + id)
            .then((res) => {
                if (res.success) {
                    let obj = {
                        state:res.data.state,
                        url:res.data.url
                    }
                    setStateLawInfo(obj)
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };


console.log("stateLawInfo",stateLawInfo)

    return (
        <div className="grid">
            <div className="col-12 md:col-12 mx-auto">
                <Toast ref={toast} />
                <div className="card ">
                {loading ? 
                    <div className="overlay-loading">
                    <div class="spinner-border text-dark" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                : null}
                    <div className=" flex justify-content-center">
                        <h3>Update State Law</h3>
                        <div className="ml-4 align-right"></div>
                    </div>
                    {/* <img src={product} alt="" width="10%" style={{ display: "block", marginLeft: "auto", marginRight: "auto" }} /> */}
                    <div className="p-fluid grid">
                        <div className="field col-12 md:col-6">
                            <span className="p-float-label mt-4">
                                <InputText id="state" name="state" onChange={(e)=>handleChange({name:e.target.name,value:e.target.value})} value={stateLawInfo.state} />
                                <label htmlFor="state">State</label>
                            </span>
                            <div className="text-danger">{err.state}</div>
                        </div>

                        <div className="field col-12 md:col-6">
                            <span className="p-float-label mt-4">
                                <InputText id="url" name="url" onChange={(e)=>handleChange({name:e.target.name,value:e.target.value})} value={stateLawInfo.url} />
                                <label htmlFor="url">URL</label>
                            </span>
                            <div className="text-danger">{err.url}</div>
                        </div>
                        
                       
                    </div>
         

                    <div className="flex justify-content-left mt-3 ">
                        {
                            <Button type="button" className="p-button-md p-button-success" onClick={handleSubmit}>
                                Update State Law
                            </Button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StateLawsEdit;
